const mediaFile = {
    albufeira66 :[
            {
                src: "https://www.youtube.com/embed/KKaxOlglNSw?controls=0&mute=1&autoplay=1",
                altText: 'Promo Video',
                caption: 'Promo Video',
                type:'video',
                key: 1,
              },
              {
                src: require('../assets/img/albufeira66/albufeira66pic1.jpg').default,
                altText: 'Albufeira 66',
                caption: 'Albufeira 66',
                type:'image',
                key: 2,
              },
              {
                src: require('../assets/img/albufeira66/albufeira66pic2.jpg').default,
                altText: 'Our Staff',
                caption: 'Our Staff',
                type:'image',
                key: 3,
              }
        ],
    heaven :[
            {
                src: "https://www.youtube.com/embed/LUs2QLT0psQ?controls=0&mute=1&autoplay=1",
                altText: 'Promo Video',
                caption: 'Promo Video',
                type:'video',
                key: 1,
              },
              {
                src: require('../assets/img/heaven/heavenpic1.jpg').default,
                altText: 'Club Heaven',
                caption: 'Club Heaven',
                type:'image',
                key: 2,
              },
              {
                src: require('../assets/img/heaven/heavenpic2.jpg').default,
                altText: 'The VIP',
                caption: 'The VIP',
                type:'image',
                key: 3,
              }
        ],
    albufissa :[
            {
                src: "https://www.youtube.com/embed/6IV7hW87KGs?controls=0&mute=1&autoplay=1",
                altText: 'Promo Video',
                caption: 'Promo Video',
                type:'video',
                key: 1,
              },
              {
                src: require('../assets/img/albufissa/albufissapic1.jpg').default,
                altText: 'Albufissa FeestCafe',
                caption: 'Albufissa FeestCafe',
                type:'image',
                key: 2,
              },
              {
                src: require('../assets/img/albufissa/albufissapic2.jpg').default,
                altText: 'Albufissa FeestCafe',
                caption: 'Albufissa FeestCafe',
                type:'image',
                key: 3,
              }
        ],
    warehouse :[
              {
                src: require('../assets/img/warehouse/warehousepic1.jpg').default,
                altText: 'Heaven Warehouse',
                caption: 'Heaven Warehouse',
                type:'image',
                key: 1,
              },
              {
                src: require('../assets/img/warehouse/warehousepic2.jpg').default,
                altText: 'Heaven Warehouse',
                caption: 'Heaven Warehouse',
                type:'image',
                key: 2,
              }
        ],
    tropicana :[
            {
                src: "https://www.youtube.com/embed/SZYnYjSWNHg?controls=0&mute=1&autoplay=1",
                altText: 'Promo Video',
                caption: 'Promo Video',
                type:'video',
                key: 1,
              },
              {
                src: require('../assets/img/tropicana/tropicanapic1.jpg').default,
                altText: 'Club Tropicana',
                caption: 'Club Tropicana',
                type:'image',
                key: 2,
              },
              {
                src: require('../assets/img/tropicana/tropicanapic2.jpg').default,
                altText: 'Club Tropicana',
                caption: 'Club Tropicana',
                type:'image',
                key: 3,
              }
        ],
    pool :[
            {
                src: "https://www.youtube.com/embed/Wj_yq9_Aeg8?controls=0&mute=1&autoplay=1",
                altText: 'Promo Video',
                caption: 'Promo Video',
                type:'video',
                key: 1,
              },
              {
                src: require('../assets/img/pool/poolpic1.jpg').default,
                altText: 'Pool Party',
                caption: 'Pool Party',
                type:'image',
                key: 2,
              },
              {
                src: require('../assets/img/pool/poolpic2.jpg').default,
                altText: 'Pool Party',
                caption: 'Pool Party',
                type:'image',
                key: 3,
              }
        ],
    boat :[
            {
                src: "https://www.youtube.com/embed/q421lygp6sQ?controls=0&mute=1&autoplay=1",
                altText: 'Promo Video',
                caption: 'Promo Video',
                type:'video',
                key: 1,
              },
              {
                src: require('../assets/img/boat/boatpic1.jpg').default,
                altText: 'Boat Party',
                caption: 'Boat Party',
                type:'image',
                key: 2,
              },
              {
                src: require('../assets/img/boat/boatpic2.jpg').default,
                altText: 'Boat Party',
                caption: 'Boat Party',
                type:'image',
                key: 3,
              }
        ],    
}

export default mediaFile